<template>
  <div class="mw-split-container bgf3 job-role">
   <unitDialog @confirm="confirmUnit" ref="unitDialog" :selectUnitId="group.unitId" ></unitDialog>
    <unitDialog @confirm="confirmUnit1" ref="unitDialog1" :selectUnitId="group.unitId" :multiple="true"></unitDialog>
    <mw-dialog size="mini_small" ref="roleDialog" title="选择角色" :footerButton="roleFooterButton" :close-on-click-modal="false">
      <mw-tree :url="roleTreeUrl" :multipleLeaf="true" :checkNodes="checkRoleIds" :async="false" :expandedFirst="true"
               ref="roleTree" :multiple="true"  ></mw-tree>
    </mw-dialog>

    <mw-dialog size="large_large"  title="选择用户" ref="userDialog" :footerButton="userFooterButton" :close-on-click-modal="false">
      <loadMan ref="userChoose" :RAdminData="chooseUsers" :defaultParentId="defaultParentId" :listAble="listAble" :isAppendDepartment="true"></loadMan>
    </mw-dialog>

    <mw-dialog ref="impDialog" title="导入角色管理数据" @opened="showUpload" size="mini_small" :footerButton="impBtton">
      <div class="mw-dialog_body" style="margin-top:20px;">
        <el-form label-width="100px">
          <el-col :span="24">
            <el-form-item label="导入说明:">
              <template>
                第一步：单击此处<el-button @click="downloadExcel" >下载模版</el-button><br/>
                第二步：按照模板格式录入角色管理数据;<br/>
                第三步：上传模板文件:
              </template>
            </el-form-item>
            <el-form-item label="上传文件:">
              <el-button ref="uploader">上传文件</el-button>
              <div class="el-upload__tip">只能上传.xls文件</div>
            </el-form-item>
          </el-col>
        </el-form>
      </div>
    </mw-dialog>
    <split-pane :defaultSize="480" split="vertical">
      <template slot="paneL">
        <div class="mw-split-left">
          <div class="mw-toolbar">
            <el-button @click="addGroup" size="mini" v-if="!isOnlySelUser"><i class="fa fa-plus-square" v-if="!btnNotShowIcon"></i>新增</el-button>
            <el-button @click="deleteGroup" size="mini" v-if="!isOnlySelUser"><i class="fa fa-trash-o" v-if="!btnNotShowIcon"></i>删除</el-button>
            <el-button @click="expand"  v-show="expandFlag==1" size="mini"><i class="fa fa-angle-double-down" v-if="!btnNotShowIcon"></i>展开</el-button>
            <el-button @click="closed"  v-show="expandFlag!=1" size="mini"><i class="fa fa-angle-double-up" v-if="!btnNotShowIcon"></i>折叠</el-button>
            <el-button @click="toGroupList" size="mini" v-if="!isOnlySelUser"><i class="fa fa-file-text-o" v-if="!btnNotShowIcon"></i>列表显示</el-button>
            <el-dropdown trigger="hover" @command="handleMoreCommand">
              <el-button class="el-dropdown-link">
                更多<i class="el-icon-caret-bottom el-icon--right"></i>
              </el-button>
              <el-dropdown-menu class="mw-toolbar-dropdown" slot="dropdown">
                <el-dropdown-item command="import" v-if="!isOnlySelUser">导入</el-dropdown-item>
                <el-dropdown-item command="export">导出</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="mw-toolbar__body">
            <mw-tree :url="groupTreeUrl" :autoLoad="false" :async="true" :contextMenuItem="isOnlySelUser?[]:contextMenuItem" :multipleLeaf="true"
              :dragEnable="true" :defaultParams="defaultTreeParams"  :expandedFirst="true" ref="groupTree" @changed="changed"  :selectFirst="true" ></mw-tree>
          </div>
        </div>
      </template>
      <template slot="paneR">
        <div class="mw-split-right">
          <div class="mw-toolbar">
            <el-button @click="saveGroup" type="primary"  size="mini"  v-loading.fullscreen.lock="loading"> <i class="fa fa-file-text-o" v-if="!btnNotShowIcon"></i>保存</el-button>
            <span style="float:right;width: 100%;">
            <el-button type="info" @click="helpnotes" style="float:right;">
              <i class="fa fa-question" v-if="!btnNotShowIcon"></i>帮助
            </el-button>
            </span>
          </div>
          <div class="mw-toolbar__body">

            <el-form class="mw-form" label-width="130px" :rules="rules" :model="group" ref="groupForm">
              <el-col :span="24">
                <el-form-item label="单位名称" prop="unitName">
                  <el-input v-model="group.unitName" readonly></el-input>
                  <el-button @click="showUnitDialog" :disabled="group.name === '默认角色'" v-if="!isOnlySelUser" :class="selIconCls||''">{{!selIconCls ? '选择' : ' '}}</el-button>
                </el-form-item>

                <el-form-item prop="unitId" v-show="false">
                  <el-input v-model="group.unitId"></el-input>
                </el-form-item>

                <el-form-item prop="code" v-show="false">
                  <el-input v-model="group.code"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item label="角色名称" prop="name">
                  <el-input v-model="group.name" :readonly="(group.name === '默认角色' && group.id.length > 0) || isOnlySelUser"></el-input>
                  <el-button @click="changeDefultRole(1)" id="defultRoleBtn" v-show="false" v-if="!isOnlySelUser">默认角色</el-button>
                  <el-button @click="changeDefultRole(2)" id="generalRoleBtn" v-show="false" v-if="!isOnlySelUser">普通角色</el-button>
                </el-form-item>
                <el-form-item prop="id" v-show="false">
                  <el-input v-model="group.id"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24" v-show="isShowCategory">
                <el-form-item label="角色分类" prop="category">
                  <el-input v-model="group.category" ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="身份权限" prop="postRoleNames">
                  <el-input type="textarea" :rows="2"
                            v-model="group.postRoleNames" readonly>
                  </el-input>
                  <el-button @click="showRoleDialog" v-if="!isOnlySelUser" :class="selIconCls||''">{{!selIconCls ? '选择' : ' '}}</el-button>
                </el-form-item>
                <el-form-item prop="postRoleIds" v-show="false">
                  <el-input v-model="group.postRoleIds"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item label="文档权限" prop="docRoleNames">
                  <el-input type="textarea" :rows="2"
                            v-model="group.docRoleNames" readonly>
                  </el-input>
                  <el-button @click="showRoleDialog" v-if="!isOnlySelUser" :class="selIconCls||''">{{!selIconCls ? '选择' : ' '}}</el-button>
                </el-form-item>
                <el-form-item prop="docRoleIds" v-show="false">
                  <el-input v-model="group.docRoleIds"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item label="流程权限" prop="flowRoleNames">
                  <el-input type="textarea" :rows="2"
                            v-model="group.flowRoleNames" readonly>
                  </el-input>
                  <el-button @click="showRoleDialog" v-if="!isOnlySelUser" :class="selIconCls||''">{{!selIconCls ? '选择' : ' '}}</el-button>
                </el-form-item>
                <el-form-item prop="flowRoleIds" v-show="false">
                  <el-input v-model="group.flowRoleIds"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="24" v-show="group.name != '默认角色'">
                <el-form-item label="用户人员" prop="userNames">
                  <el-input type="textarea" :rows="2" v-model="group.userNames" readonly>
                  </el-input>
                  <el-button @click="userChoose" :class="selIconCls||''">{{!selIconCls ? '选择' : ' '}}</el-button>
                </el-form-item>
                <el-form-item prop="userDeptIdentityIds" v-show="false">
                  <el-input v-model="group.userDeptIdentityIds"></el-input>
                </el-form-item>
                <el-form-item prop="departmentIds" v-show="false">
                  <el-input v-model="group.departmentIds"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item label="角色描述" prop="dec">
                  <el-input v-model="group.dec"></el-input>
                </el-form-item>
              </el-col>

            </el-form>
          </div>
        </div>
      </template>
    </split-pane>

  </div>
</template>
<script>
  import loadMan from "./user/loadManager.vue";
  import unitDialog from "./user/unitDialog";
  import { mapGetters } from 'vuex';
  // import role from "./user/roleInf.vue"

  export default {
    components: {
      loadMan,
      unitDialog
    },
    data() {
      let me = this;
      let isShowCategory = !!(window.$Env && $Env.jobRoleShowCategory);
      let defaultParams = {isShowChild:true,type:'auth',unitId:"",isShowCategory:isShowCategory};
      let allIdentityRoleNames = me.$store.getters.expUser.allIdentityRoleNames;
      let isOnlySelUser = false;
      let groupTreeUrl=this.mwUrl('/api/org/getGroupTreeByType');
      let params = this.$options.parent.$attrs && this.$options.parent.$attrs.params;
      if(allIdentityRoleNames && allIdentityRoleNames.indexOf("系统管理员")==-1 && me.$store.getters.expUser.unitAdmin){
        let unitObj = me.$store.getters.unitDepartments;
        defaultParams.unitId = me.$store.getters.curSelUnitId || (unitObj && unitObj[0].id) || "";
        if(params && params.unitAdmin == 'onlySelUser'){
          isOnlySelUser = true;
        }
      }
      if(params && params.groupTreeUrl){
          groupTreeUrl=params.groupTreeUrl;
      }
      return {
        expandFlag:1,
        userDialogVisible: false,
        firstTime : true,
        isShowCategory:isShowCategory,
        selIconCls:(window.$Env && $Env.selIconCls),
        btnNotShowIcon:(window.$Env && $Env.btnNotShowIcon),
        defaultTreeParams:defaultParams,
        groupTreeUrl: groupTreeUrl,
        unitTreeUrl: this.mwUrl('/api/org/getUnitTree'),
        roleTreeUrl: this.mwUrl('/api/org/listAllGroupedRole'),
        contextMenuItem: [
          {name: 'add', icon: 'fa fa-plus-square', label: '新增', func: me.addGroup},
          {name: 'delete',label: '删除',icon: 'fa fa-trash-o',func: me.deleteGroup}
        ],
        unitFooterButton: [
          {label: '确定', func: me.selectUnitSure},
          {label: '取消', func: me.selectUnitCancel,type: 'default'}
        ],
        roleFooterButton: [
          {label: '确定', func: me.selectRoleSure},
          {label: '取消', func: me.selectRoleCancel,type: 'default'}
        ],
        userFooterButton: [
          {label: '确定', func: me.selectUserSure},
          {label: '取消', func: me.cancelSelectUser,type: 'default'}
        ],
        isOnlySelUser:isOnlySelUser,
        checkRoleIds: [],
        selectUnitId: '',
        curUnitId:'',
        group: {
          id: '',
          code: '',
          dec: '',
          name: '',
          unitId: '',
          category:'',
          unitName: '',
          userDeptIdentityIds: '',
          departmentIds: '',
          userNames: '',
          roleIds: '',
          roleNames: '',
          postRoleNames:'',
          postRoleIds:'',
          docRoleNames:'',
          docRoleIds:'',
          flowRoleNames:'',
          flowRoleIds:''
        },
        rules: {
          name: [
            {required: true, message: '请输入名称', trigger: 'blur'},
          ],
          unitName: [
            {required: true, message: '请输入选择单位', trigger: 'change'},
          ]
        },
        chooseUsers: [],
        defaultParentId: '',
        listAble: false,
        loading: false,
        change: false,
        reset: false,
        form1: {},
        importAction:'/api/org/importJobRoleFromExcel',
        impBtton:[ {
          label: "取消",
          type: "default",
          func:this.impCancel
        }],
        isFirstOpen:true,
      }
    },
    mounted() {
    //  this.defaultTreeParams.t = Date.now() ;
      var isSysAdmin = this.isSysAdmin();
      this.listAble = !this.userInfo.developer;
      if(window.$Env && window.$Env.jobSelectUserListAble){
        this.listAble = !!window.$Env.jobSelectUserListAble;
      }
      if(this.userInfo.developer || isSysAdmin){
        this.curUnitId = this.userInfo.owner||"";
      }else{
        if(this.userInfo.loginUnitModel)
           this.defaultTreeParams.unitId = this.userInfo.loginUnitModel.id;
        if(this.$store.getters.curUnit && this.$store.getters.curUnit.length > 0){
          this.curUnitId = this.$store.getters.curUnit[0].id;
        }
      }
      this.mwRef("groupTree").renderTree();
    },
    methods: {
       showUpload(){
         if(this.isFirstOpen){
           this.initUploader();
           this.isFirstOpen=false;
         }
       },
       initUploader(){
          let me=this;
          let cfg={
            buttonId:me.mwRef('uploader').$el,
            maxSize:500,
            action:me.importAction,
            autoUpload: true,
            accept:"xls"
          }
          let fn={
            fileUploaded(up, file,resp){
               me.importSuccessCallback(resp,file,up);
             }
          }
          PF.initPupload(cfg,fn);
       },
      //树选择
      changed(data) {
        let me = this;
        if(this.change){
          this.$confirm('文档修改后尚未保存，是否保存?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          me.saveGroup();
        }).catch(() => { me.refresh();});
          me.change =  false;
        }else{
        if (data.id && data.hasChild == 0) {
            me.setShowDefultBtn(data.unitId);
            me.resetFields();
            me.mwApi.org.getGroup(data.id).then(res => {
              for(let i in res.result){
                me.form1[i] = res.result[i]
              }
             me.mwUtil.applyCover(me.group, res.result);
            })
            this.reset = false;
        }
        }
      },
      processTreeParams:function(params){
      },
      isSysAdmin(){
        if(this.userInfo.roleNames && this.userInfo.roleNames.indexOf("系统管理员") !=-1){
          return true;
        }
        return false;
      },
      confirmUnit(){
        var data =this.mwRef('unitDialog').getValue();
          this.group.code = data.id;
          this.group.unitId = data.id;
          this.group.unitName = data.text;
          this.setShowDefultBtn(data.id);

      },
      confirmUnit1(){
        var data =this.mwRef('unitDialog1').getValue();
        let ids=data.map((v)=>{return v.id});
        this.mwUtil.downloadAttachment(this.mwUrl("/api/org/exportJobRoleToExcel"),{codes:ids.join(",")},false,"");
      },
      showUnitDialog() {
        let me = this;
        me.selectUnitId = me.group.unitId;
        this.mwRef('unitDialog').show();
        MW.test(function(){
          if(me.mwRef('unitDialog').mwRef('unitTree'))
           return true;
           return false;
        },function(){
          me.mwRef('unitDialog').mwRef('unitTree').defaultParams.parentId=me.curUnitId;
          me.mwRef('unitDialog').mwRef('unitTree').renderTree();
        },50);
      },

      userChoose() {
        // this.userDialogVisible = true;
        if(this.group.code){
          this.mwRef('userDialog').show();
          this.chooseUsers = [];
          if(!this.firstTime){
          this.mwRef('userChoose').refreshTree(true);
          }
          this.firstTime = false;
          this.defaultParentId =  this.group.code;
          if (this.group.userNames) {
            let names = this.group.userNames.split(',');
            let ids = this.group.userDeptIdentityIds.split(',');
            let departmentIds =  this.group.departmentIds.split(',');
            for (let i = 0; i < names.length; i++) {
              this.chooseUsers.push({
                departmentId: departmentIds[i],
                name: names[i],
                identityId: ids[i]
              })
            }
        }}else{
          this.mwMsg('请选择单位');
        }
      },

      //显示角色树
      showRoleDialog() {
        let me = this;
        me.checkRoleIds = [];
        if (me.group.postRoleIds) {
          me.checkRoleIds = me.checkRoleIds.concat(me.group.postRoleIds.split(','));
        }
        if (me.group.docRoleIds) {
          me.checkRoleIds = me.checkRoleIds.concat(me.group.docRoleIds.split(','));
        }
        if (me.group.flowRoleIds) {
          me.checkRoleIds = me.checkRoleIds.concat(me.group.flowRoleIds.split(','));
        }
        this.mwRef('roleDialog').show();
      },


      //选择用户
      selectUserSure() {
        this.mwRef('userDialog').hide();
        this.group.userNames = '';
        this.group.userDeptIdentityIds = '';
        this.group.departmentIds= '';
        let data = this.mwRef('userChoose').getValue();
        let userNames = [];
        let userDeptIdentityIds = [];
        let departmentIds = [];
        data.forEach(d => {
          userNames.push(d.name);
          userDeptIdentityIds.push(d.identityId);
          departmentIds.push(d.departmentId);
        });

        this.group.userNames = userNames.join();
        this.group.userDeptIdentityIds = userDeptIdentityIds.join();
        this.group.departmentIds = departmentIds.join();

      },
      helpnotes(){
        PF.showHelp({url:'/helpDoc/platform/role_management.md'})
      },
      resetFields() {
        this.reset = true;
        this.mwRef('groupForm').resetFields();
      },

      cancelSelectUser(){
         this.mwRef('userDialog').hide();
      },

      //选择权限
      selectRoleSure() {
        let postRoleIds = [], postRoleNames = [], docRoleIds = [], docRoleNames = [], flowRoleIds = [], flowRoleNames = [];
        this.mwRef('roleTree').getSelected().forEach(d => {
          if(d.type&&d.type=="1"){
            postRoleIds.push(d.id);
            postRoleNames.push(d.text);
          }else if(d.type&&d.type=="2"){
            docRoleIds.push(d.id);
            docRoleNames.push(d.text);
          }else if(d.type&&d.type=="3"){
            flowRoleIds.push(d.id);
            flowRoleNames.push(d.text);
          }
        });
        this.group.postRoleIds = postRoleIds.join();
        this.group.postRoleNames = postRoleNames.join();
        this.group.docRoleIds = docRoleIds.join();
        this.group.docRoleNames = docRoleNames.join();
        this.group.flowRoleIds = flowRoleIds.join();
        this.group.flowRoleNames = flowRoleNames.join();
        this.selectRoleCancel();

      },

      selectRoleCancel() {
        this.mwRef('roleDialog').hide()
      },

      addGroup() {
        $("#defultRoleBtn").hide();
        $("#defultRoleBtn").hide();
        this.resetFields();
        var date = this.mwRef('groupTree').getSelected();
        this.group.unitName = date.unitName?date.unitName:date.name;
        this.group.unitId = date.unitId?date.unitId:date.id;
        this.group.code = date.unitId?date.unitId:date.id;
        this.setShowDefultBtn(this.group.unitId);
      },

      saveGroup() {
        let me = this;
        me.mwRef('groupForm').validate((valid => {
          if (valid) {
            if(me.group.postRoleIds==""&&me.group.docRoleIds==""&&me.group.flowRoleIds==""){
              this.mwMsg('warning','权限角色至少选择一个');
              return;
            }
            if(me.group.name === '默认角色' && !me.group.id){

                me.mwApi.org.listGroupPagingByAuthType({start: 0, limit: 2000, code: me.group.code, sorts: [], type: "auth"}).then(res =>{
                    if(res.success){
                      if(res.result.length > 0){
                       res.result.forEach( (r,index) =>{
                        if(r.name === me.group.name){
                          me.mwMsg('warning','该单位下默认角色不可重复添加');
                          return;
                        }else{
                          if(index ===  res.result.length -1){
                            me.loading = true;
                            me.mwApi.org.saveGroup(me.group).then(data => {
                              me.loading = false;
                                if (data.success) {
                                  me.mwMsg('权限组保存成功');
                                  me.refresh();
                                }
                                else {
                                  me.mwMsg('权限组保存失败')
                                }
                            }).catch((data)=>{
                              this.loading = false;
                            });
                          }
                        }
                       })
                      }else if(res.result.length == 0){
                          me.loading = true;
                          me.mwApi.org.saveGroup(me.group).then(data => {
                            me.loading = false;
                              if (data.success) {

                                me.mwMsg('权限组保存成功');
                                me.refresh();
                              }
                              else {
                                me.mwMsg('权限组保存失败')
                              }
                          }).catch((data)=>{
                            this.loading = false;
                          });
                      }
                    }
                })
            }else{
              this.loading = true;
              me.mwApi.org.saveGroup(me.group).then(data => {
                this.loading = false;
              if (data.success) {

                 me.mwMsg('权限组保存成功');
                me.refresh();
              }
              else {
                me.mwMsg('权限组保存失败')
              }
            }).catch((data)=>{
                this.loading = false;
              });
            }
          } else {
            me.mwMsg('warning', '请输入完整信息')
          }
        }));
      },
      deleteGroup(data) {
        let me = this;
        //this.defaultTreeParams.t = Date.now();
        if(!data.id){
          if(this.mwRef('groupTree').getSelected()){
            data = this.mwRef('groupTree').getSelected();
          }else{
            me.mwMsg('请选择要删除的节点!');
          }
        }
        // if(data.name === '默认角色'){
        //   this.mwMsg('warning','默认角色不允许删除');
        //   return;
        // }
        if (data.hasChild == 0) {
          me.mwConfirm('您确定要删除此权限组').then(() => {
            me.mwApi.org.deleteGroup(data.id).then(res => {
              if (res.success) {
                me.mwMsg('删除成功');
                me.refresh()
              } else {
                me.mwMsg('warning', '删除失败');
              }
            })
          }).catch(() => {

          });
        } else {
          me.mwConfirm('您确定要删除此单位权限组').then(() => {
            me.mwApi.org.deleteGroupByUnit(data.id).then(res => {
              if (res.success) {
                me.mwMsg('删除成功');
                me.refresh()
              } else {
                me.mwMsg('warning', '删除失败');
              }
            })
          }).catch(() => {

          });
        }
      },

      resetFields() {
        this.mwRef('groupForm').resetFields();
      },
      refresh() {
        //this.defaultTreeParams.t = Date.now() ;
        $("#generalRoleBtn").hide();
        $("#defultRoleBtn").hide();
        this.resetFields();
        this.mwRef('groupTree').refresh();
      },
      expand() {
        this.expandFlag = 2;
        this.mwRef('groupTree').openAll();
      },
      closed() {
        this.expandFlag = 1;
        this.mwRef('groupTree').closeAll();
      },
      toGroupList(){
        //this.$router.push({ path: '/set/group/list'})
        //因切换后开发环境导航点组织机构没有切换，所以开发环境用户还是原先的路由
         if(!window["$servicePath"]){
           this.$router.push({ path: '/org/group/list'})
         }else{
            var p=this.$parent;
             do{
                 if(p.changeView){
                   p.changeView("systemSet_org_roleList");
                 }
                     p=p.$parent;
             }while(p);
         }
      },
      changeDefultRole(type){
        if(type&&type=="1"){
          this.group.name='默认角色';
          $("#generalRoleBtn").show();
          $("#defultRoleBtn").hide();
        }else{
          this.group.name='';
          $("#generalRoleBtn").hide();
          $("#defultRoleBtn").show();
        }
      },
      setShowDefultBtn(unitid){  //如果存在默认角色，则不显示默认角色按钮
        var params = {code:unitid,start:0,limit:2000};
        this.mwApi.org.listGroupPagingByAuthType(params).then(res => {
          var showDefultBtn = 0;
          for(var y=0;y<res.result.length;y++){
            if(res.result[y].name=="默认角色"){
              showDefultBtn = 1;
            }
          }
          if(showDefultBtn==0){
            $("#defultRoleBtn").show();
          }else{
            $("#defultRoleBtn").hide();
          }
        })
      },
      handleMoreCommand(command){
        let me=this;
        if(command === 'import'){
          this.mwRef('impDialog').show();
        }
        if(command === 'export'){
          this.mwRef('unitDialog1').show();
          MW.test(function(){
          if(me.mwRef('unitDialog1').mwRef('unitTree'))
           return true;
           return false;
        },function(){
          me.mwRef('unitDialog1').mwRef('unitTree').defaultParams.parentId=me.curUnitId;
          me.mwRef('unitDialog1').mwRef('unitTree').renderTree();
        },50);
        }
      },
      import(){
        let me=this;
        me.mwRef("importData").submit();
      },
      impCancel(){
        this.mwRef('impDialog').hide();
      },
      importSuccessCallback(response, file, fileList) {
        if (this.mwRef("importData") && typeof this.mwRef("importData").clearFiles == 'function') this.mwRef("importData").clearFiles();
        if(response.result){
          this.mwRef('groupTree').refresh();
          PF.show('message',{html:response.result.errMsg});
          this.mwRef('impDialog').hide();
        }
      },
      downloadExcel(){
        var me = this;
        me.mwUtil.downloadAttachment("/template_file/importJobRoleExcel.xls");
      }
    },
    computed: {
    ...mapGetters([
        'userInfo',
        'expUser'
      ]),
    },
    watch:{
      group:{
        handler(curVal,oldVal){
         if(!this.reset){
          this.change = false;
          for(let i in curVal){

            if(curVal[i]){
              if(!this.form1[i]){
                this.form1[i] = ''
              }
              if((curVal[i] != this.form1[i])){
                this.change = true;
              }
          }}}
　　　　},
　　　　deep:true
      }
    }

  }
</script>
<style scoped>
  .el-tree-node__content .el-checkbox {
    display: none;
  }

  .el-input, .el-textarea {
    width: 60%;
  }

</style>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/org/jobRole.vue